<template>
    <div class="row mt-5">
        <div class="col-md-3 spark-settings-tabs">
            <aside>
                <h3 class="nav-heading ">
                    Options
                </h3>
                <ul class="nav flex-column mb-4 ">
                    <li class="nav-item">
                        <a class="nav-link active" href="#reports" aria-controls="reports" role="tab" data-toggle="tab" @click="toggleSchedule(1)">
                            Reports/Exports
                        </a>
                    </li>
                    <li class="nav-item" v-if="!isPm">
                        <a class="nav-link" href="#charts" aria-controls="reports" role="tab" data-toggle="tab" @click="toggleSchedule(0)">
                            Graph/Charts
                        </a>
                    </li>
                </ul>
            </aside>
        </div>
        <div class="col-md-9">
            <div class="pull-right">
                <button
                    class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                    @click="generateReport" type="button">
                    Get Report
                </button>

                <button v-if="team.has_scheduled_reports_access && showSchedule && !this.isPm && userRole !== 'view_only'"
                        class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white ml-3 px-3 rounded-full text-followup-nav"
                        @click.prevent="openScheduler" type="button">
                    Schedule
                </button>
            </div>
            <div class="tab-content">
                <div role="tabcard" class="tab-pane active" id="reports" >
                    <h3 class="nav-heading ">
                        Reports / Exports
                    </h3>
                    <div class="rounded w-full px-2 text-grey-darkest">
                        <div v-if="!isPm" v-for="report of reports_exports" :key="report.id">
<!--                            <span v-if="report.id === 'sales-meeting-overview'">-->
<!--                                <input type="radio" name="to_generate" :value="getValue(report)" :id="report.id" v-model="selectedReport" @click="openSalesStatusModal">-->
<!--                                <label :for="report.id" @click="openSalesStatusModal">{{report.name}}</label>-->
<!--                            </span>-->
                            <span>
                                <input type="radio" name="to_generate" :value="getValue(report)" :id="report.id" v-model="selectedReport">
                                <label :for="report.id">{{report.name}}</label>
                            </span>
                        </div>
                    </div>
                    <div v-if="isPm">
                        <input type="radio" name="to_generate" :value="{id: 'excel-export', name: 'Excel Export'}" id="excel-export" v-model="selectedReport">
                        <label for="excel-export">Excel Export</label>
                    </div>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane" id="charts">
                    <h3 class="nav-heading ">
                        Charts / Graphs
                    </h3>
                    <div class="rounded w-full px-2 text-grey-darkest">
                        <div v-for="chart of graphs_charts" :key="chart.id">
                            <input type="radio" name="to_generate" :value="getValue(chart)"   id="" v-model="selectedReport">
                            <label :for="chart.name">{{chart.name}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="scheduleReport" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h4 class="text-center mb-2">Automated Report Scheduling
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </h4>
                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm" for="email_subject">Email Subject <span class="text-danger">*</span></label>
                            <input type="text" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" v-model="scheduleReportForm.subject" name="email_subject" id="email_subject" placeholder="Enter email subject"/>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.subject">{{ scheduleReportErrors.subject }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm">Recipients <span class="text-danger">*</span></label>
                            <multiselect v-model="scheduleReportForm.recipients"
                                         id="recipientEmailSelected"
                                         tag-placeholder="Press enter to add"
                                         placeholder="Add an email"
                                         :options="options"
                                         :multiple="true"
                                         track-by="email"
                                         label="email"
                                         :taggable="true"
                                         :close-on-select="false"
                                         @tag="addRecipient">
                                <template v-slot:noOptions>
                                    <span style="display:none"> List is empty. </span>
                                </template>
                            </multiselect>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.recipients">{{ scheduleReportErrors.recipients }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="delivery_frequency">Delivery Frequency <span class="text-danger">*</span></label>
                            <select name="delivery_frequency" id="delivery_frequency" v-model="scheduleReportForm.delivery_frequency"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" required @change="frequencyChanged($event)" >
                                <option selected disabled>Select frequency</option>
                                <option value="Daily">Daily</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Monthly">Monthly</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.delivery_frequency">{{ scheduleReportErrors.delivery_frequency }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm mb-0"
                                   for="scheduled_time">Scheduled Time <span class="text-danger">*</span></label>
                            <p><small>Data is captured up to 2 hours before the email is sent. This is to make sure this email is delivered as on-time as possible.</small></p>
                            <datetime type="time" name="scheduled_time" format="hh:mm a" use12-hour :minute-step="15" required v-model="scheduleReportForm.scheduled_time" id="scheduled_time" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control"></datetime>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_time">{{ scheduleReportErrors.scheduled_time }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="scheduled_day">Delivery Day <span class="text-danger">*</span></label>
                            <select name="scheduled_day" id="scheduled_day" v-model="scheduleReportForm.scheduled_day"
                                    class="p-1 border-1 focus:outline-none text-grey-darkest text-sm form-control" :disabled="scheduleReportForm.scheduled_day_disabled">
                                <option selected disabled>Select date</option>
                                <option value="monday">Monday</option>
                                <option value="tuesday">Tuesday</option>
                                <option value="wednesday">Wednesday</option>
                                <option value="thursday">Thursday</option>
                                <option value="friday">Friday</option>
                                <option value="saturday">Saturday</option>
                                <option value="sunday">Sunday</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_day">{{ scheduleReportErrors.scheduled_day }}</span>
                        </div>

                        <div class="form-group mb-2" v-if="selectedReport && selectedReport.excel === true && selectedReport.pdf === true">
                            <label class="text-grey-darkest text-sm"
                                   for="report_format">Format <span class="text-danger">*</span></label>
                            <select name="report_format" id="report_format" v-model="scheduleReportForm.report_format"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control">
                                <option selected disabled>Select report format</option>
                                <option value="pdf">PDF</option>
                                <option value="excel">Excel</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.report_format">{{ scheduleReportErrors.report_format }}</span>
                        </div>

                        <div class="form-group mb-2" v-if="selectedReport && selectedReport.id === 'lead-recap'">
                            <label class="text-grey-darkest text-sm">Lead From <span class="text-danger">*</span></label>
                            <multiselect
                                :options="leadOptions"
                                v-model="scheduleReportForm.selected_leads"
                                :show-labels="false"
                                track-by="id"
                                label="code"
                                group-values="leadOptions"
                                group-label="label"
                                :group-select="true"
                                class="mb-2 cursor-pointer"
                                :multiple="true"
                            > </multiselect>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.selected_leads">{{ scheduleReportErrors.selected_leads }}</span>
                        </div>

                        <div class="text-center mt-4">
                            <button class="btn btn-primary rounded-full" @click="scheduleReport">
                                Schedule Report Email
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="modal" id="exampleModal" tabindex="-1">-->
<!--            <div class="modal-dialog modal-dialog-centered">-->
<!--                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">-->
<!--                    <div class="modal-header">-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">SELECT SALES STATUS</div>-->
<!--                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">-->
<!--                                <div class="rounded w-full px-2 text-grey-darkest">-->
<!--                                    <div class="flex text-center mb-3">-->
<!--                                        <button class="btn-link mr-3" for="all" @click="selectAllSales">Select all </button>-->
<!--                                        <button class="btn-link" for="none" @click="selected_sales_status = []">Clear all  </button>-->
<!--                                    </div>-->
<!--                                    <div class="text-justify overflow-y-auto" style="max-height: 60vh">-->
<!--                                        <div v-for="status of sales_status" :key="status.id">-->
<!--                                            <input type="checkbox" name="status" :value="status.id" id="" v-model="selected_sales_status">-->
<!--                                            <label :for="status.short_description">{{status.short_description}}</label>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="modal-footer">-->
<!--                        <button-->
<!--                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none"-->
<!--                            style="background-color: #0a66c2 !important;" type="button" @click="closeSaleStatusModal">-->
<!--                            Done-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import Mixin from './mixin';
import Form from "../../utils/form";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
    mixins: [Mixin],
    name: 'general-report',
    props: ['filter-uri', 'is-pm', 'userRole', 'team'],
    components: {Multiselect},
    data() {
        return {
            selectedReport: null,
            showSchedule: true,
            reports_exports: [
                { id: 'avarage-project-size/contract-date', name: "Average Project Size by Contract Date", excel: false, pdf: true },
                { id: 'avarage-project-size/proposal-date', name: "Average Project Size by Proposal Date", excel: false, pdf: true },
                { id: 'bid-list', name: "Bid List", excel: true, pdf: true },
                { id: 'bid-proposal', name: "Bid Proposal Report", excel: true, pdf: true },
                { id: 'captured-contracts', name: "Won Contracts", excel: true, pdf: true },
                { id: 'client-sales-history', name: "Client Sales History", excel: true, pdf: true },
                { id: 'client-profile-summary-report', name: "Client Profile Summary Report", excel: true, pdf: true },
                { id: 'company-export', name: 'Company Export', excel: true, pdf: false },
                { id: 'company-contact-export', name: 'Company Contact Export', excel: true, pdf: false},
                { id: 'dashboard', name: "Activities", excel: false, pdf: true },
                { id: 'dead-recap', name: "Dead Recap", excel: true, pdf: true},
                { id: 'excel-client', name: "Excel Client / Sales Export", excel: true, pdf: false},
                { id: 'excel-export', name: "Excel Export", excel: true, pdf: false },
                { id: 'excel-export-bid-to', name: "Excel Export (Bid To)", excel: true, pdf: false },
                { id: 'gross-margin-captured-projects', name: "Gross Margin Captured Projects", excel: true, pdf: true },
                { id: 'lead-recap', name: "Lead Recap Report", excel: false, pdf: true },
                { id: 'monthly-activity', name: "Monthly Activity", excel: false, pdf: true },
                { id: 'monthly-activity-no-comments', name: "Monthly Activity - No Comments", excel: false, pdf: true },
                { id: 'executive-overview', name: "Executive Overview", excel: true, pdf: false },
                { id: 'change-order', name: "Change Order", excel: true, pdf: false },
                { id: 'sales-meeting-overview', name: "Sales Meeting Overview", excel: true, pdf: true },
                { id: 'quick-bid-sales', name: "Quick Bid Sales", excel: false, pdf: true },
                { id: 'sales-goals', name: "Sales Goals", excel: true, pdf: true },
            ],
            graphs_charts: [
                { id: 'closing-ratio', name: "Closing Ratio Chart", excel: false },
                { id: 'gross-margin-pipeline', name: "Gross Margin Pipeline Chart", excel: false },
                // { id: 'monthly-bid-totals', name: "Monthly Bid Totals Bar Chart", excel: false },
                { id: 'monthly-captured-contracts', name: "Monthly Captured Contracts Bar Chart", excel: false },
                { id: 'monthly-proposal-delivered', name: "Monthly Proposals Delivered Bar Chart", excel: false },
                { id: 'sales-behavior-summary', name: "Sales Activity Summary Chart", excel: false },
                { id: 'sales-pipeline', name: "Sales Pipeline Chart", excel: false },
            ],
            scheduleReportForm : new Form({
                subject: '',
                recipients:[],
                delivery_frequency: '',
                scheduled_time: '',
                scheduled_day: '',
                report_id: '',
                report_name: '',
                report_format: '',
                'start-date': '',
                'end-date': '',
                user: '',
                office: '',
                'contract-type': '',
                'fixed-date-range-identifier': '',
                selected_leads : '',
                scheduled_day_disabled : false,
            }),
            scheduleReportHasError: false,
            scheduleReportErrors: {
                subject:'',
                recipients:'',
                delivery_frequency:'',
                scheduled_time:'',
                scheduled_day:'',
                report_format:'',
                selected_leads:'',
            },
            options                         : [],
            leadOptions: [
                {
                    label: 'All',
                    leadOptions:[],
                }
            ],
            sales_status:[],
            selected_sales_status: [],
        }
    },

    watch: {
        selectedReport(report){
            this.$emit('change-report',report.id);
        },
        scheduleReportForm: {
            immediate: false,
            handler: function (scheduleValue, oldVal) {
                if(scheduleValue.subject!==""){
                    this.scheduleReportErrors.subject='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.recipients.length > 0){
                    this.scheduleReportErrors.recipients='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.delivery_frequency!==""){
                    this.scheduleReportErrors.delivery_frequency='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.scheduled_time!==""){
                    this.scheduleReportErrors.scheduled_time='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.scheduled_day!==""){
                    this.scheduleReportErrors.scheduled_day='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.report_format!==""){
                    this.scheduleReportErrors.report_format='';
                    this.scheduleReportHasError = false
                }
            },
            deep: true
        },
    },
    created() {
        this.getLeads();
        this.getSalesStatus();
    },
    mounted() {
        if(this.team.has_probability_access == 1) {
            this.reports_exports.splice(14, 0, { id: 'forecasting-report', name: "Forecasting Report", excel: true, pdf: true });
        }
    },
    methods: {
        frequencyChanged(event) {
            console.log(event.target.value)
            if(event.target.value === "Daily") {
                this.scheduleReportForm.scheduled_day_disabled = true
            }else {
                this.scheduleReportForm.scheduled_day_disabled = false
            }
        },
        getValue(report){
            return {
                id: report.id,
                name: report.name,
                excel: report.excel,
                pdf: report.pdf ?? null
            }
        },

        generateReport() {
            if(this.selectedReport)  {
                let path = '';

                let uri = this.filterUri.substr(0, this.filterUri.length);
                uri += '&name=' + this.getSelectedReportValue();

                if(this.selectedReport.id !== 'lead-recap') {
                    if(!this.selectedReport.excel){
                        uri += '&pdf=true';
                    }else if(!this.selectedReport.pdf) {
                        uri += '&excel=true';
                    }
                }

                if(this.selectedReport.id === 'sales-meeting-overview'){
                    uri += '&sales_status=['+this.selected_sales_status+']';
                }
                if(this.selectedReport.id === 'company-export') {
                    path += "/reports-charts/" + this.selectedReport.id +'-excel'+ uri;
                }else{
                    path += "/reports-charts/" + this.selectedReport.id + uri;
                }

                if(this.selectedReport.id.includes('avarage-project-size')) {
                    let split = this.selectedReport.id.split('/');
                    uri += '&type=' + split[1];
                    path = '/reports-charts/' + split[0] + uri;
                }

                if(this.isPm) {
                    path = '/project-management' + path;
                }

                if (this.checkValidations(path)){
                    return;
                }
                // if(this.selectedReport.id == 'excel-export'){
                //     let self = this;
                //     self.fireSuccessToast('Your report is being processed.');
                //     axios.get(path).then(response => {
                //         console.log('Your report is done.check your notification.')
                //     }).catch(error => {
                //         if(error){
                //             Swal.fire({
                //                 title: "Message",
                //                 text: "This is not a bug! You just don't have access to this record. Ask your administrator for more details.",
                //                 confirmButtonColor: 'red',
                //                 dangerMode: true,
                //             });
                //         }
                //     });
                // }else {
                    this.createPop(path, this.selectedReport);
                // }

            }
        },

        getSelectedReportValue() {
            if (this.selectedReport.id.includes('excel')) {
                return this.selectedReport.name.replace(/[^\w\s]/gi, '');
            }

            return this.selectedReport.name;
        },

        openScheduler() {
            if(this.selectedReport)  {
                this.scheduleReportForm.reset();
                this.scheduleReportForm.scheduled_day_disabled = false
                if(this.selectedReport.pdf && !this.selectedReport.excel) {
                    this.scheduleReportForm.report_format = 'pdf'
                }else if(!this.selectedReport.pdf && this.selectedReport.excel){
                    this.scheduleReportForm.report_format = 'excel'
                }
                if(this.selectedReport.id==='dead-recap'){
                    this.scheduleReportForm.report_format = 'pdf'
                }

                this.scheduleReportErrors = {
                    subject:'',
                    recipients:'',
                    delivery_frequency:'',
                    scheduled_time:'',
                    scheduled_day:'',
                    report_format:'',
                    selected_leads:'',
                }
                $("#scheduleReport").modal("show");
            }
        },
        addRecipient(newEmail) {
            let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (newEmail.match(mailFormat)) {
                const tag = {
                    email: newEmail,
                };
                this.scheduleReportForm.recipients.push(tag);
            } else {
                this.fireErrorToast("You have entered an invalid email address!");
            }
        },
        toggleSchedule(val) {
            if(val) {
                this.showSchedule = true
            }else{
                this.showSchedule = false
            }
        },
        scheduleReport() {
            this.scheduleReportHasError = false;
            this.scheduleReportForm.report_name = this.selectedReport.name
            this.scheduleReportForm.report_id = this.selectedReport.id
            this.validateField('subject', 'Subject');
            this.validateField('recipients', 'Recipients');
            this.validateField('delivery_frequency', 'Delivery Frequency');
            this.validateField('scheduled_time', 'Scheduled Time');
            if(this.scheduleReportForm.delivery_frequency != "Daily"){
                this.validateField('scheduled_day', 'Delivery Day');
            }

            if(this.selectedReport.pdf && this.selectedReport.excel) {
                this.validateField('report_format', 'Format');
            }
            if(this.selectedReport.id === 'lead-recap') {
                this.validateField('selected_leads', 'Lead From');
            }
            if(this.scheduleReportHasError) {
                return false
            }

            const params = this.filterUri.replace('?','').split('&');
            params.map((param) => {
                const filter = param.split('=')
                this.scheduleReportForm[filter[0]] = filter[1];
            })

            if(this.scheduleReportForm.selected_leads.length > 0) {
                this.scheduleReportForm.selected_leads = JSON.stringify(this.scheduleReportForm.selected_leads.map(x => x.id))
            }
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            axios.post(route('api.schedule-report.store'), this.scheduleReportForm).then(response => {
                if (response.data.status) {
                    Toast.fire({
                        type: "success",
                        title: response.data.message
                    });
                    this.scheduleReportForm.reset();
                    $("#scheduleReport").modal("hide");
                } else {
                    Toast.fire({
                        type: "error",
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                console.log('error', error);
            })
        },
        validateField(fieldName, fieldLabel) {
            if(fieldName === 'recipients') {
                if(this.scheduleReportForm[fieldName].length === 0) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }else if(fieldName === 'selected_leads') {
                if(this.scheduleReportForm[fieldName].length === 0) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }else{
                if(!this.scheduleReportForm[fieldName].trim()) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }

        },
        getLeads(){
            let self = this;
            axios.get(route('api.settings.codes.lead-from.index')).then((response) => {
                // self.leadOptions = response.data;
                // self.leadOptions.unshift({id: 0, code: 'All'});

                self.leadOptions[0].leadOptions = [...response.data];

            });
        },

        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'success',
                title: message,
            });

            // this.updatePreview();
        },
        closeSaleStatusModal(){
            $('#exampleModal').modal('hide');
        },
        openSalesStatusModal(){
            $('#exampleModal').modal('show');
        },
        getSalesStatus(){
            axios.get(route('api.settings.codes.sales-status.index')).then((response) => {
                this.sales_status = response.data;
            });
        },
        selectAllSales(){
            this.selected_sales_status = [];
            this.sales_status.forEach(status => {
                this.selected_sales_status.push(status.id)
            });
        },
    }
};
</script>

<style lang="scss" escoped>
.schedule-modal{
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 3px #333;
}
#scheduleReport .modal-dialog{
    top: 8vh;
}
</style>
